import paypal from '@/services/paypal.vue';

export default {
    install(Vue, options) {
        //var context = null;
        //Vue.mixin({
        //    created() {
        //        context = this;
        //    }
        //});
        paypal.options = options;
        Vue.component('paypal', paypal);
    }
}
